/* eslint-disable camelcase */
import axios from '@axios'

export const state = {
  transactionsReports: [],
  creditReports: [],
  monthlyExports: [],
  totalCredit: 0,
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecords: 0,
}

export const getters = {
  allTransactionsReports: (state) => state.transactionsReports,
  allCreditReports: (state) => state.creditReports,
  allMontlyExports: (state) => state.monthlyExports,
  totalCredit: (state) => state.totalCredit,
  currentPage: (state) => state.currentPage,
  totalPage: (state) => state.totalPage,
  totalRecords: (state) => state.totalRecords,
  perPage: (state) => state.perPage,
}

export const mutations = {
  GET_TRANSACTION_REPORTS: (state, data) => {
    if (!data) {
      state.transactionsReports = []
      state.currentPage = 1
      state.perPage = 15
      state.totalPage = 1
      state.totalRecords = 0
      return false
    }
    let { transactions, page, perPage, totalRecords, totalPages } = data
    state.transactionsReports = transactions
    state.currentPage = page
    state.totalPage = totalPages
    state.perPage = perPage
    state.totalRecords = totalRecords
  },
  GET_CREDIT_REPORTS: (state, data) => {
    if (!data) {
      state.creditReports = []
      state.currentPage = 1
      state.perPage = 15
      state.totalPage = 1
      state.totalRecords = 0
      return false
    }
    let { reports, page, perPage, totalPages, totalRecords, total } = data
    state.totalCredit = total
    state.creditReports = reports
    state.currentPage = page
    state.totalPage = totalPages
    state.perPage = perPage
    state.totalRecords = totalRecords
  },
  GET_MONTHLY_EXPORT: (state, data) => {
    if (!data) {
      state.exports = []
      return false
    }
    state.monthlyExports = data.reports
  },
  DELETE_MONTHLY_REPORT: (state, report) => {
    state.monthlyExports = state.exports.filter((exp) => exp.id !== report.id)
  },
}

export const actions = {
  async getTransactionReports({ commit, dispatch }, { paginate }) {
    await axios
      .get(`/ip/report/transaction`, { params: paginate })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_TRANSACTION_REPORTS', resp.data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_TRANSACTION_REPORTS', {})
        dispatch('layout/changeLoading', false, { root: true })
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async getCreditReports({ commit, dispatch }, { paginate }) {
    await axios
      .get(`/ip/report/credit-usage`, { params: paginate })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_CREDIT_REPORTS', resp.data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_CREDIT_REPORTS', {})
        dispatch('layout/changeLoading', false, { root: true })
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async exportTraffice({ commit, dispatch }, { params }) {
    return axios.get(`/ip/report/transaction/export`, { params: params })
  },
  async exportCredit({ commit, dispatch }, { params }) {
    return axios.get(`/ip/report/credit-usage/export`, { params: params })
  },
  async getMonthlyExports({ commit }) {
    await axios
      .get('/ip/report/monthly-credit-report')
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_MONTHLY_EXPORT', resp.data)
        } else {
          commit('GET_MONTHLY_EXPORT', null)
        }
      })
      .catch(() => {
        commit('GET_MONTHLY_EXPORT', null)
      })
  },
  async deleteMonthlyExport({ commit }, report) {
    await axios
      .delete(`/ip/report/monthly-credit-report/${report.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_REPORT', report)
        }
      })
  },
}
